export default __webpack_public_path__ + "static/7-59037d71c5518bc8dff7891f60d8eedc.webp";